import { useLocation } from 'react-router-dom';

import { useIsMobile } from '@/lib/hooks/useMobile';
import { useChatStore, useSettingsStore } from '@/store';


export const Footer = () => {
  const { pathname } = useLocation();

  const { chatInputFocused } = useChatStore();

  const hideFooter = pathname?.startsWith('/chat');
  const isMobile = useIsMobile();

  const { settings } = useSettingsStore();
  const footerLinks = settings?.ui?.links?.footerLinks || [];


  if (hideFooter && isMobile && chatInputFocused) {
    return null;
  }

  return (
    <footer className="border-t bg-secondary backdrop-blur-2xl border-primary/30">

      {/* Sub Footer */}
      <div className="border-t">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-muted-foreground">
              © {new Date().getFullYear()} GTT Data Ltd. All
              rights reserved.
            </div>
            <div className="flex flex-wrap gap-6">
              {footerLinks.map((link) => (
                <a
                  key={link.label}
                  href={''}
                  target="_blank"
                  rel="noreferrer"
                  className="text-muted-foreground hover:text-primary transition-colors text-sm"
                  data-testid="footer-links-2"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
